(() => {

  const GIFT_PRODUCT_HANDLE = 'silk-sleep-mask';

  async function refreshCartDrawer() {

    const response = await fetch(
      '/?sections=cart-drawer,cart-icon-bubble'
    );

    const sections = await response.json();

    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    cartDrawer.renderContents({
      sections: {
        'cart-drawer': sections['cart-drawer'],
        'cart-icon-bubble': sections['cart-icon-bubble']
      }
    });

  }

  async function addGift(variantId) {

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

  }

  document.addEventListener('click', async (event) => {

    const button = event.target.closest('#gift-add-button');

    if (!button) return;

    event.preventDefault();

    const selector = document.querySelector(
      '#gift-variant-selector'
    );

    if (!selector) return;

    const variantId = selector.value;

    if (!variantId) return;

    button.disabled = true;
    button.classList.add('loading');
    button.innerHTML = 'Adding...';

    try {

      await addGift(variantId);

      await refreshCartDrawer();

    } catch (error) {

      console.error(
        '[Gift Offer]',
        error
      );

    } finally {

      button.disabled = false;
      button.classList.remove('loading');
      button.innerHTML = 'Add Free Gift';

    }

  });

})();